import "core-js/modules/es6.reflect.construct.js";
import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.array.slice.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.regexp.to-string.js";
import "core-js/modules/es6.regexp.split.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from "react";
import { DicimalFormater } from "./utils";
export default function sum(Table) {
  var precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  return /*#__PURE__*/function (_React$Component) {
    _inherits(SumTable, _React$Component);

    var _super = _createSuper(SumTable);

    //无状态
    function SumTable(props) {
      var _this;

      _classCallCheck(this, SumTable);

      _this = _super.call(this, props); //array , tree

      _defineProperty(_assertThisInitialized(_this), "getNodeItem", function (array, newArray) {
        array.forEach(function (da, i) {
          if (da.children) {
            _this.getNodeItem(da.children, newArray);
          } else {
            newArray.push(da);
          }
        });
      });

      _defineProperty(_assertThisInitialized(_this), "getTableType", function () {
        var columns = _this.props.columns;
        var type = "array";
        columns.find(function (da, i) {
          if (da.children) {
            type = "tree";
            return type;
          }
        });
        return type;
      });

      _defineProperty(_assertThisInitialized(_this), "addSumData", function () {
        var _this$props = _this.props,
            _this$props$data = _this$props.data,
            data = _this$props$data === void 0 ? [] : _this$props$data,
            _this$props$columns = _this$props.columns,
            columns = _this$props$columns === void 0 ? [] : _this$props$columns;
        var sumdata = {},
            newColumns = [],
            newData = [];

        if (!Array.isArray(columns)) {
          console.log("columns type is error !");
          return;
        }

        var type = _this.getTableType();

        if (type == 'tree') {
          _this.getNodeItem(columns, newColumns);
        } else {
          newColumns = columns;
        } //返回一个新的数据


        newData = data.slice();
        newColumns.forEach(function (column, index) {
          sumdata[column.dataIndex] = "";

          if (column.sumCol) {
            var count = 0;
            data.forEach(function (da, i) {
              var _num = parseFloat(da[column.key]); //排查字段值为NAN情况


              if (_num == _num) {
                count += _num;
              }
            });

            var _sum = DicimalFormater(count, precision);

            if (column.sumThousandth) {
              _sum = _this.toThousands(_sum);
            }

            sumdata[column.dataIndex] = _sum;

            if (column.sumRender && typeof column.sumRender == 'function') {
              sumdata[column.dataIndex] = column.sumRender(_sum);
            }
          }

          if (index == 0) {
            sumdata[column.dataIndex] = "合计 " + sumdata[column.dataIndex];
          }
        });
        newData.push(sumdata);
        return newData;
      });

      _this.tableType = "array";
      return _this;
    }

    _createClass(SumTable, [{
      key: "toThousands",
      value: function toThousands(num) {
        var result = '',
            counter = 0;
        num = (num || 0).toString();
        var numArr = num.split('.');
        num = numArr[0];

        for (var i = num.length - 1; i >= 0; i--) {
          counter++;
          result = num.charAt(i) + result;

          if (!(counter % 3) && i != 0) {
            result = ',' + result;
          }
        }

        return numArr.length === 1 ? result : result + '.' + numArr[1];
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/React.createElement(Table, _extends({}, this.props, {
          columns: this.props.columns,
          showSum: true,
          data: this.addSumData()
        }));
      }
    }]);

    return SumTable;
  }(React.Component);
}


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-table/src/lib/sum.js